<template>
  <div v-if="parameter" class="max-width">
    <div v-if="parameter.__type === 'decimal'" class="max-width center-content">
      <b-col md="7" class="no-padding-right-left">{{ getPropertyDescription(parameter.name) }}</b-col>
      <b-col md="5" class="no-padding-right-left">
        <div
          class="pull-right"
        >
          {{ getFormattedValue() }}
        </div>
      </b-col>
    </div>

    <div v-if="parameter.__type === 'boolean'" class="max-width center-content">
      <b-col md="7" class="no-padding-right-left">{{ getPropertyDescription(parameter.name) }}</b-col>
      <b-col md="5" class="no-padding-right-left">
        <div class="pull-right">
          {{ getFormattedValue() }}
        </div>
      </b-col>
    </div>
    
  </div>
</template>

<script>

import { DxTextBox, DxNumberBox, DxSwitch } from 'devextreme-vue'
import { DMVFee } from '../components/index'

export default {
  name: 'DMVFee',
  props: {
    parameter: null,
    propertyDescriptions: null
  },
  components: {
    DxTextBox,
    DxNumberBox,
    DxSwitch,
    DMVFee
  },
  data () {
    return {
    }
  },
  methods: {
    getPropertyDescription(name) {
      const pd = this.propertyDescriptions.find(x => x.Name === name)
      if (pd) {
        return pd.Description
      } else {
        return name
      }
    },
    getFormattedValue() {
      let formattedValue = this.parameter.value.toString()

      if (this.parameter.__type === 'decimal') {
        const indexOfDecimal = this.parameter.value.toString().indexOf('.')
        if (indexOfDecimal > 0) {
          if (formattedValue.length == indexOfDecimal + 3) {
            formattedValue = parseFloat(formattedValue).toFixed(2).toString().substring(0, indexOfDecimal + 3)
          }
          if (formattedValue.length >= indexOfDecimal + 4) {
            formattedValue = parseFloat(formattedValue).toString().substring(0, indexOfDecimal + 4)
          }
        }
        
        if (this.parameter.name.toLowerCase().endsWith('pct')) {
          formattedValue += ' %'
        } 
      }
      
      return formattedValue
    }
  },
  computed: {
  }
}
</script>

<style>
  .max-width {
    width: 100%;
  }

  .no-padding-right-left {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }

  .center-content {
     display:flex;
     align-items:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/DMVFee.vue